import { ControlProps, rankWith, uiTypeIs } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { Button } from "../../elements/Button";
import { useDynamicFormContext } from "../../../DynamicFormContext";
import { getActions } from "../../../../../utils/DynamicForms";
import { Tooltip } from "../../../../Tooltip";
import "./style.scss";
import { useState } from "react";
import { CircularProgress } from "@mui/material";
import { uniqueId as generateUniqueId } from "lodash";

type Props = ControlProps;

const ButtonControl = (props: Props) => {
  const [clickedButtonId, setClickedButtonId] = useState("");
  const [uniqueId] = useState(generateUniqueId("button_"));
  const { handleActions, isActionsPending } = useDynamicFormContext();
  const actions = getActions(props.uischema);
  // const icon = props.uischema.options?.icon;

  const handleClick = async (event: any) => {
    setClickedButtonId(event.target.id);
    if (!actions?.length) return;
    await handleActions(actions);
    setClickedButtonId("");
  };

  if (!props.visible) return null;

  const tooltip = props.uischema.options?.tooltip;

  const ButtonElement = (
    <Button
      type={props.uischema.options?.style || "primary"}
      onMouseDown={handleClick}
      // onClick={handleClick}
      classes={`${props.uischema.options?.classes} ${
        !props.enabled || props.uischema.options?.disabled ? "disabled" : ""
      }`}
      // disabled={!props.enabled}
      disabled={
        props.uischema.options?.disabled ||
        props.enabled === false ||
        Object.values(isActionsPending).includes(true)
      }
      id={uniqueId}
    >
      {/* {icon ? <Icon name={icon} size="extra-medium" /> : props.label} */}
      {(clickedButtonId !== uniqueId ||
        !Object.values(isActionsPending).includes(true)) &&
        props.label}
      {clickedButtonId === uniqueId &&
        Object.values(isActionsPending).includes(true) && (
          <CircularProgress size={20} color="inherit" />
        )}
    </Button>
  );

  if (!!tooltip)
    return (
      <Tooltip title={tooltip.title} position={tooltip.position}>
        {ButtonElement}
      </Tooltip>
    );

  return ButtonElement;
};

export const ButtonControlEntry = {
  tester: rankWith(1, uiTypeIs("ButtonControl")),
  renderer: withJsonFormsControlProps(ButtonControl),
};
